import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ICondoAmenitiesFacilities, IDetails } from '@share/common-types';

import './style.scss';

interface IProps {
  condoDetails: IDetails;
  refAnchor: React.RefObject<HTMLDivElement>;
}

interface IState {
  isFullAmenities: boolean;
}

const ZERO = 0;
const MAX_ACTIVITIES_COUNT = 9;

export class CondoActivities extends React.Component<IProps, IState> {
  state: IState = {
    isFullAmenities: false,
  };

  toggleAmenities = (): void => {
    this.setState(({ isFullAmenities }) => ({
      isFullAmenities: !isFullAmenities,
    }));
  };

  getDistance = (amenity: ICondoAmenitiesFacilities): React.ReactNode => {
    return (
      (amenity.distanceInKms > ZERO || amenity.distanceInMiles > ZERO) && (
        <p className="condo-activities__distance">
          (
          {amenity.distanceInKms > ZERO ? (
            <FormattedMessage id="distance.km" values={{ distance: amenity.distanceInKms }} />
          ) : null}
          {amenity.distanceInKms > ZERO && amenity.distanceInMiles > ZERO && '/'}
          {amenity.distanceInMiles > ZERO ? (
            <FormattedMessage id="distance.miles" values={{ distance: amenity.distanceInMiles }} />
          ) : null}
          )
        </p>
      )
    );
  };

  render(): React.ReactNode {
    const { condoDetails, refAnchor } = this.props;
    const { activities } = condoDetails;
    const { isFullAmenities } = this.state;

    const activityItemsToShow: ICondoAmenitiesFacilities[] = isFullAmenities
      ? activities
      : activities.slice(ZERO, MAX_ACTIVITIES_COUNT);

    return (
      <div className="condo-activities" ref={refAnchor}>
        <h2 className="condo-activities__title secondary-font">
          <FormattedMessage id="tab.activities" />
        </h2>
        <div className="condo-activities__items">
          {activityItemsToShow.map((amenity, index) => {
            return (
              <div className="condo-activities__item" key={index}>
                <span className="condo-activities__text">{amenity.name}</span>
                <div className="condo-activities__proximity">
                  {amenity.proximity ? (
                    <FormattedMessage id={`proximity.${amenity.proximity}.title`} />
                  ) : null}
                  {this.getDistance(amenity)}
                </div>
              </div>
            );
          })}
        </div>
        {activities.length > MAX_ACTIVITIES_COUNT && (
          <div className="condo-activities__show-link" onClick={this.toggleAmenities}>
            {isFullAmenities ? (
              <FormattedMessage id="show.less" />
            ) : (
              <FormattedMessage id="show.more" values={{ count: activities.length }} />
            )}
          </div>
        )}
      </div>
    );
  }
}

